import { render, staticRenderFns } from "./TrademarkObjectionToOpposingViewStatusList.vue?vue&type=template&id=41210849&"
import script from "./TrademarkObjectionToOpposingViewStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToOpposingViewStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToOpposingViewStatusList.vue?vue&type=style&index=0&id=41210849&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports